<template>
  <span class="editable-price" :class="{ 'editable-price--editable': canEditPrice }" v-click-outside="cancelEditing">
    <!-- Display mode -->
    <span v-if="!isEditing" @click="startEditing" :style="canEditPrice ? 'cursor: pointer' : ''">
      <slot></slot>
    </span>

    <!-- Edit mode -->
    <span v-else class="editable-price__editor">
      <span class="editable-price__dollar">$</span>
      <input
        ref="priceInput"
        type="text"
        class="editable-price__input"
        v-model="editValue"
        @input="limitDecimals"
        @keydown.enter="savePrice"
        @keydown.escape="cancelEditing"
      />
      <button class="editable-price__btn" @mousedown.prevent="savePrice" :disabled="saving">
        Update
      </button>
    </span>
  </span>
</template>

<script>
export default {
  name: 'EditablePrice',
  props: {
    productId: {
      type: [Number, String],
      required: true
    },
    currentPrice: {
      type: [Number, String],
      required: true
    },
    field: {
      type: String,
      default: 'price'
    }
  },
  data() {
    return {
      isEditing: false,
      editValue: '',
      saving: false,
      canEditPrice: window.Trillion.canUpdateStorefrontPrice || false
    }
  },
  methods: {
    startEditing() {
      if (!this.canEditPrice) return
      this.editValue = parseFloat(this.currentPrice).toFixed(2)
      this.isEditing = true
      this.$nextTick(() => {
        this.$refs.priceInput.focus()
        this.$refs.priceInput.select()
      })
    },
    cancelEditing() {
      if (!this.isEditing) return
      this.isEditing = false
      this.editValue = ''
    },
    limitDecimals() {
      const match = this.editValue.match(/^(\d*\.?\d{0,2})/)
      this.editValue = match ? match[1] : ''
    },
    savePrice() {
      if (this.saving) return

      const newPrice = parseFloat(this.editValue)
      if (isNaN(newPrice) || newPrice <= 0 || newPrice > 100000) {
        this.$errorNotify('Invalid price. Must be between $0.01 and $100,000.')
        return
      }

      this.saving = true

      $.ajax({
        method: 'PUT',
        url: `${window.Trillion.baseUrl}/products/${this.productId}/inline-price`,
        data: { price: newPrice, field: this.field }
      })
        .then((response) => {
          this.isEditing = false
          this.$emit('price-updated', response.data)
          this.$successNotify('Price updated to $' + newPrice.toFixed(2))
        })
        .catch((xhr) => {
          const msg = xhr.responseJSON ? xhr.responseJSON.message : 'Failed to update price'
          this.$errorNotify(msg)
        })
        .always(() => {
          this.saving = false
        })
    }
  }
}
</script>

<style lang="scss">
.editable-price {
  display: inline;

  &--editable:hover {
    opacity: 0.85;
  }

  &__editor {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  &__dollar {
    font-weight: 700;
    color: #DEAA5E;
  }

  &__input {
    width: 80px;
    padding: 2px 6px;
    border: 1px solid #DEAA5E;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    outline: none;

    &:focus {
      border-color: #c9952e;
      box-shadow: 0 0 0 2px rgba(222, 170, 94, 0.25);
    }
  }

  &__btn {
    padding: 2px 8px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.4;
    color: #fff;
    background: #DEAA5E;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      background: #c9952e;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>
